export default __webpack_public_path__ + "static/media/border-crossing.367c20f4.svg";